<template>
  <div> 
    <input type="hidden" name="captcha_settings" :value='settingsComp'>
    <div class="g-recaptcha" :id="identifier" ref="recaptcha" data-theme="light" :data-sitekey="dataSitekey"></div>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'nt-recaptcha',
  props: {
    identifier: {
      type: String,
      default: `recaptcha-${Math.floor(Math.random() * 100)}`
    },
    chaptchaSettings: {
      type: Object,
      default: () => {
        return {
          keyname: 'cbmm_api_key_pair',
          fallback: 'true',
          orgId: '00D1k000000EYOo',
          ts: ''
        }
      }
    },
    dataSitekey: {
      type: String,
      required: true
    },
    validators: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      error: null,
      settings: this.chaptchaSettings
    }
  },
  computed: {
    settingsComp() {
      return JSON.stringify(this.settings)
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.identifier, _.first))[0]
    }
  },
  created() {
    // window.onloadCallback = this.onloadCallback

    const { validators } = this.$parent.$data

    // Add validators to form
    Object.assign(validators, {
      [this.identifier]: this.validators
    })

    setInterval(this.updateCaptchaSettings, 500)
  },
  mounted() {
    this.render()
  },
  methods: {
    verifyCallback(data) {
      window.console.log(data)
    },
    onloadCallback() {
      window.grecaptcha.render(this.identifier, {
        callback: this.verifyCallback
      })
    },
    updateCaptchaSettings() {
      const response = document.getElementById('g-recaptcha-response')

      if (response === null || response.value.trim() === '') {
        Object.assign(this.settings, { ts: new Date().getTime().toString() })
      }
    },
    render() {
      if (window.recaptcha) {
        this.onloadCallback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .g-recaptcha {
        display: inline-block;
    }
</style>